export default __webpack_public_path__ + "static/media/sf_1.51227f8a.PNG";